<template>
  <v-dialog
    v-model="dialogModel"
    transition="slide-y-reverse-transition"
    :persistent="persistent"

    :width="getWidth"
    :fullscreen="fullScreen && $vuetify.breakpoint.smAndDown"
    :content-class="contentClass"
    :class="[
      {'rounded-dialog': rounded},
      {'no-shadow-mobile': moveUpOnMobile}
    ]"
    content-class="no-shadow-mobile"
    @input="onDialogChange"
  >
    <v-card v-if="dialogModel" id="Card" :class="[
        {'rounded-card': rounded},
        {'move-up-mobile': moveUpOnMobile}
      ]" class="fullHeight">
      <close-dialog v-if="close" :close-dialog="close" />

      <div id="dialog-body" :class="applyPaddingClass">
        <slot name="body">
        </slot>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import CloseDialog from "@/components/Common/CloseDialog"

export default {
  components: { CloseDialog },

  props: {
    rounded: {
      type: Boolean,
      default: false
    },
    getter: {
      type: Boolean,
      default: false
    },
    setter: {
      type: Function,
      default: () => {}
    },
    moveUpOnMobile: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      default: null
    },

    applyPadding: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    },
    fullScreen: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '500px'
    },
    contentClass: {
      type: String,
      default: ''
    }
  },

  computed: {
    dialogModel: {
      set(val) { this.setter(val) },
      get() { return !!this.getter }
    },

    getWidth() {
      if (this.fullScreen) {
        return this.$vuetify.breakpoint.smAndDown ? '' : '500'
      } else {
        return this.width
      }
    },
    applyPaddingClass() {
      return this.rounded ? 'applyPadding-rounded' : 'applyPadding-default';
    }
  },

  methods: {
    closeAction() {
      if (this.close !== null) {
        this.close()
      } else {
        this.setter(false)
      }
    },
    onDialogChange(val) {
      if (val) {
        this.$emit('opened');
      }
    }
  },
  watch: {
    dialogModel: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$emit('opened');
        }
      }
    }
  }
}
</script>

<style scoped>
  @media (max-width: 600px) {
    #Card.move-up-mobile {
      margin-bottom: 40vh;
    }
  }
  .rounded-dialog.v-dialog {
    border-radius: 16px !important;
    overflow: hidden !important;
  }

  .rounded-card {
    border-radius: 16px !important;
    overflow: hidden !important;
  }
  
  .applyPadding-default {
    padding: 20px 20px 70px;
  }

  .applyPadding-rounded {
    padding: 20px 20px 20px;
  }

  #Card #dialog-body {
    width: 100%;
    height: 100%;

    text-align: left !important;
  }

  .applyPadding {
    padding: 20px 20px 20px;
  }
</style>
<style>
  @media (max-width: 600px) {
    .no-shadow-mobile.v-dialog {
      box-shadow: none !important;
    }
    
    .no-shadow-mobile .v-card {
      box-shadow: none !important;
    }
}</style>